export default {
    "fsm_settings_break_notifyAt": "Notificar en",
    "fsm_settings_break_breakDuration": "Duración del descanso",
    "fsm_settings_break_contacts": "Contactos",
    "fsm_settings_break_mins": "Mins",
    "FSM_SETTINGS_TIME_CARD_meal_break_notifications": "Notificaciones de descanso para comer",
    "FSM_SETTINGS_TIME_CARD_meal_break_success": "Notificación de descanso para comer editada con éxito",
    "fsm_settings_break_error_contacts": "Por favor seleccione uno o más contactos",
    "fsm_settings_break_error_notify": "Por favor, seleccione Notificar a la hora"
};